<template>
    <div>

        <section class="page-banner page-banner-sec">
            <h1 class="section-title">{{ $t('forgot_password.header') }}</h1>
        </section>

        <div id="layout-content" class="pt-4">

            <div class="container">

                <h2>{{ $t('forgot_password.title') }}</h2>

                <div v-if="error" class="alert alert-error">{{ error }}</div>

                <form v-if="!changed" @submit.prevent="submitPassword">

                    <div class="row mb-4">
            			<div class="col-md">
                            <label class="font-weight-bold m-0">{{ $t('fields.password') }}</label>
                            <password v-model="forgot.password" defaultClass="form-control strongPassword" :badge="false" @score="strength" placeholder="" />
                        </div>
                        <div class="col-md">
                            <label class="font-weight-bold m-0">{{ $t('fields.password_confirm') }}</label>
                            <b-form-input v-model="forgot.password_confirmation" type="password"></b-form-input>
                        </div>
                    </div>

                    <p><button class="btn btnSubmit btn-primary p-2">{{ $t('forgot_password.button') }}</button></p>

                </form>

                <div v-if="changed" class="alert alert-success alert-styled-left alert-arrow-left" v-html="$t('forgot_password.success')"></div>

                <p class="mt-3"><router-link :to="{ name: 'login' }" class="btn btnSubmit btn-secondary p-2" tag="button">{{ $t('login.back') }}</router-link></p>

            </div>

        </div>

    </div>
</template>

<script>
// Vuex Stores
import { mapActions, mapGetters } from 'vuex'

// Common OTU Components
import { EventBus, mapNotificationEventActions } from '@/lib/events.js';
import { errHandler } from '@/lib/handlers'

export default {
	name: 'PasswordChange',
    components: {
        Password: () => import('vue-password-strength-meter')
    },
	data () {
		return {
            forgot: {},
            strengthScore: 0,
            changed: false,
            error: null
        }
	},
	created () {
        this.forgot.token = this.$route.params.hash;
    },
	methods: {
		...mapActions(['userPassword']),
		...mapNotificationEventActions,
        strength (score) {
            this.strengthScore = score;
        },
        submitPassword () {
            if (this.checkForm()) {
                this.userPassword(this.forgot).then((v) => {
                    this.changed = v;
                }).catch((err) => this.emitError({msg: this.$t('forgot_password.error') }));
            }
        },
        checkForm () {

            let passed = true;

            if (this.forgot.password == null) {
                this.emitError({msg: this.$t('fields.errors.password') });
                passed = false;
            }

            if (this.forgot.password != null && this.strengthScore < 3) {
                this.emitError({msg: this.$t('fields.errors.password_strength') });
                passed = false;
            }

            if (this.forgot.password != this.forgot.password_confirmation) {
                this.emitError({msg: this.$t('fields.errors.password_match') });
                passed = false;
            }

            return passed;

        }
	}
}
</script>
